export default __webpack_public_path__ + "components/weather-icon/static/nightmodsnow-acc6a005f8734b1d2b294670721e064d.webp";